import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

export function ThemedIcon({ light, dark, className = "" }) {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  if (typeof light === "string" && typeof dark === "string") {
    return <img src={isDark ? dark : light} alt="" className={className} />;
  }

  const Icon = isDark ? dark : light;
  return <Icon className={className} />;
}

export function IconWrap({ children, className = "" }) {
  return (
    <div
      className={cn(
        "w-8 h-8 bg-commerce-09 flex items-center justify-center rounded",
        className
      )}
    >
      {children}
    </div>
  );
}
